export function parsePaginationFromHeaders(headers = {}, fallbackPerPage = 20) {
  const header = (k) => {
    //porsiacaso hay un guard
    if (!headers) return undefined;
    return headers[k] ?? headers[k.toLowerCase()];
  };

  const total = Number(header('X-Total-Count') ?? header('x-total-count') ?? 0);
  const per_page = Number(header('X-Per-Page') ?? header('x-per-page') ?? fallbackPerPage);
  const page = Number(header('X-Page') ?? header('x-page') ?? 1);
  const totalPagesHeader = header('X-Total-Pages') ?? header('x-total-pages');
  const totalPages = Number(totalPagesHeader ?? Math.ceil(total / (per_page || 1)));

  return { total, totalPages: Math.max(1, totalPages || 1), page, per_page };
}
